export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./smartsoft.vue?vue&type=template&id=051bed5b&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/smartsoft.vue?vue&type=template&id=051bed5b&scoped=true
// module id = /TUz
// module chunks = 0